import { useSyncExternalStore } from 'react';

/** Kurze Hinweise unten am Bildschirm, optional mit Aktion (z. B. „Rückgängig“). Für Screenreader als status. */
export interface Toast {
  id: number;
  text: string;
  /** `success`: ruhige besondere Rückmeldung (AF13, z. B. Meilenstein erreicht) */
  kind: 'info' | 'error' | 'success';
  action?: { label: string; run: () => void };
}

let toasts: Toast[] = [];
/** Für Tests: aktuelle Hinweise */
export const currentToasts = (): readonly Toast[] => toasts;
let next = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function toast(text: string, opts: { kind?: Toast['kind']; action?: Toast['action']; ms?: number } = {}): number {
  const id = next++;
  toasts = [...toasts.slice(-2), { id, text, kind: opts.kind ?? 'info', action: opts.action }];
  emit();
  timers.set(id, setTimeout(() => dismiss(id), opts.ms ?? (opts.action ? 7000 : 4000)));
  return id;
}

const timers = new Map<number, ReturnType<typeof setTimeout>>();

/** AF13: Hinweise verschwinden nicht, während man mit ihnen arbeitet (Zeiger darauf, Fokus darin) */
export function hold(id: number) {
  clearTimeout(timers.get(id));
  timers.delete(id);
}

export function release(id: number, ms = 3000) {
  if (!toasts.some((x) => x.id === id)) return;
  clearTimeout(timers.get(id));
  timers.set(id, setTimeout(() => dismiss(id), ms));
}

export function dismiss(id: number) {
  clearTimeout(timers.get(id));
  timers.delete(id);
  const before = toasts.length;
  toasts = toasts.filter((t) => t.id !== id);
  if (toasts.length !== before) emit();
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => {
        listeners.delete(fn);
      };
    },
    () => toasts,
  );
}
